import { render, staticRenderFns } from "./UserSubscriptionDetails.vue?vue&type=template&id=f8bf91d8&scoped=true"
import script from "./UserSubscriptionDetails.vue?vue&type=script&lang=js"
export * from "./UserSubscriptionDetails.vue?vue&type=script&lang=js"
import style0 from "./UserSubscriptionDetails.vue?vue&type=style&index=0&id=f8bf91d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8bf91d8",
  null
  
)

export default component.exports